<template lang="pug">
  div.waste-generators.legal-entities
    e-toolbar(
    :items="items"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    )
    e-table(
    :items="items"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showCheckbox="false"
    :showDownloadButton="true"
    @download="onDownload"
    )

    router-view
</template>

<script>
  import {wasteGenerators} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  export default {
    mixins: [tableMixin],
    computed: {
      exportItemsToFormat () {
        return 'csv'
      }
    },
    methods: {
      getDownloadEndpoint () {
        return null
      },
      getEndpoint (route) {
        return wasteGenerators.legals(
          tableMixin.methods.getPrevOrCurrentRouteQuery(route)
        )
      },
      getDeleteUrl (id) {
        return wasteGenerators.legalDelete(id)
      }

    }
  }
</script>
